import { Box, Button, Select } from '@chakra-ui/react';

import { Department } from '../models/careers';

type DepartmentListProps = {
  departments: Department[];
  selectedDepartment: Department;
  onDepartmentSelect: (department: Department) => void;
};

export function DepartmentList({ departments, selectedDepartment, onDepartmentSelect }: DepartmentListProps) {
  return (
    <Box>
      {/* Select input for mobile view */}
      <Select
        aria-label='Select Department'
        display={{ base: 'block', lg: 'none' }}
        value={selectedDepartment || 'all'}
        onChange={(event) => onDepartmentSelect(event.target.value)}
      >
        {departments.map((department) => (
          <option key={department} value={department}>
            {department}
          </option>
        ))}
      </Select>

      {/* List for desktop view */}
      <Box
        display={{ base: 'none', lg: 'flex' }}
        flexDirection='column'
        gap='8px'
        margin='24px 0'
        overflow='auto'
        padding='0 2px'
      >
        {departments.map((department) => (
          <Button
            key={department}
            _active={{ bg: 'blue.500', color: 'white' }}
            _hover={{ bg: 'blue.500', color: 'white' }}
            bg={department === selectedDepartment ? 'blue.500' : 'gray.100'}
            border='1px solid #DFDFDF'
            color={department === selectedDepartment ? 'white' : 'black'}
            justifyContent='left'
            overflow='hidden'
            padding='16px'
            variant='ghost'
            width='100%'
            onClick={() => onDepartmentSelect(department)}
          >
            {department}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
